import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const Circle: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <circle cx="5" cy="5" r="4.5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg {...props} width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};